/**
 * Tutorial onboarding — visual variants for hero art (not UI screenshots).
 */

/** Under gradient art when the PNG top is light; matches darkTheme.background.primary */
export const TUTORIAL_SLIDE_BACKGROUND_FALLBACK = '#0F0A1A';

export const TUTORIAL_SLIDE_VISUAL = {
  CORE_ACTION: 'core_action',
  REWARD: 'reward',
  SOCIAL_FLEX: 'social_flex',
} as const;

export type TutorialSlideVisual = (typeof TUTORIAL_SLIDE_VISUAL)[keyof typeof TUTORIAL_SLIDE_VISUAL];
